<template>
  <div v-if="nextVideo" class="next-video">
    <h6 class="next-video__play-next">Play the next video:</h6>
    <div @click="playNextVideo()" class="next-video__placeholder">
      <PlayButtonIcon class="next-video__play-btn-icon" />
    </div>
    <div class="next-video__title-wrapper">
      <VideoCameraIcon class="next-video__camera-icon" />
      <p class="next-video__title">{{ nextVideo.title }}</p>
    </div>
  </div>
</template>

<script>
import PlayButtonIcon from '@/assets/icons/course/quiz/play_button.svg'
import VideoCameraIcon from '@/assets/icons/course/quiz/video_camera.svg'

export default {
  name: 'NextVideo',
  components: {
    PlayButtonIcon: { ...PlayButtonIcon, name: 'PlayButtonIcon' },
    VideoCameraIcon: { ...VideoCameraIcon, name: 'VideoCameraIcon' },
  },
  props: {
    nextVideo: {
      type: Object,
      required: false,
    },
  },
  methods: {
    playNextVideo() {
      const { uuid } = this.nextVideo
      this.$store.dispatch('content/setPlayingVideoId', uuid)
      this.$store.dispatch('content/setCurrentQuizId', null)
    },
  },
}
</script>

<style lang="scss" scoped>
.next-video {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 0 0 50px;
  position: relative;
  height: 500px;
  &__play-next {
    position: absolute;
    top: 0;
    width: 100%;
  }
  &__placeholder {
    background: var(--black);
    height: 300px;
    width: 100%;
    display: flex;
    align-items: center;
    position: absolute;
    cursor: pointer;
  }
  &__play-btn-icon {
    margin: 0 auto;
  }
  &__title-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    position: absolute;
    bottom: 40px;
  }
  &__camera-icon {
    margin: 20px 0 0 0;
  }
  &__title {
    margin: 0;
    font-size: 1rem;
  }
}
</style>
